// SLA Policy API Service - Backend Integration
import { apiGet, apiPost, apiPut, apiDelete } from '../services/apiClient';

// Helper to wrap response in { data: ... } format for backward compatibility with axios-style responses
const wrapResponse = (data) => ({ data });

export const getSLAPolicies = async (params = {}) => {
  // Use gateway path: /gateway/registration/api/signup/organization/sla-policies
  const endpoint = '/gateway/registration/api/signup/organization/sla-policies';
  
  // Prepare query parameters
  const queryParams = {};
  
  // If fetchAll is true, don't pass page/size
  if (params.fetchAll) {
    queryParams.fetchAll = true;
  } else {
    queryParams.page = params.page || 0;
    queryParams.size = params.size || 100;
  }
  
  if (params.organizationId) queryParams.organizationId = params.organizationId;
  if (params.categoryId) queryParams.categoryId = params.categoryId;
  if (params.priorityId) queryParams.priorityId = params.priorityId;
  if (params.isActive !== undefined) queryParams.isActive = params.isActive;
  
  try {
    const response = await apiGet(endpoint, queryParams);
    // Backend returns: { data: { content: [...], totalElements, totalPages, ... } }
    return wrapResponse(response);
  } catch (error) {
    console.error('Failed to fetch SLA policies from backend:', error);
    throw error;
  }
};

export const getSLAPolicyById = async (policyId) => {
  const endpoint = `/gateway/registration/api/signup/organization/sla-policies/${policyId}`;
  
  try {
    const response = await apiGet(endpoint);
    return wrapResponse(response);
  } catch (error) {
    console.error('Failed to fetch SLA policy by ID from backend:', error);
    throw error;
  }
};

export const createSLAPolicy = async (data) => {
  const endpoint = '/gateway/registration/api/signup/organization/sla-policies';
  const response = await apiPost(endpoint, data);
  return wrapResponse(response);
};

export const updateSLAPolicy = async (policyId, data) => {
  const endpoint = `/gateway/registration/api/signup/organization/sla-policies/${policyId}`;
  const response = await apiPut(endpoint, data);
  return wrapResponse(response);
};

export const deleteSLAPolicy = async (policyId) => {
  const endpoint = `/gateway/registration/api/signup/organization/sla-policies/${policyId}`;
  const response = await apiDelete(endpoint);
  return wrapResponse(response);
};

// Service object for backward compatibility
export const slaPolicyService = {
  getSLAPolicies,
  getSLAPolicyById,
  createSLAPolicy,
  updateSLAPolicy,
  deleteSLAPolicy
};

export default slaPolicyService;

